module.exports = __webpack_public_path__ + "img/logo.d12e5478.png";